<template>
  <div class="wl-price-list">
    <div class="row">
      <div class="col-12 text-center">
        <b-nav small pills align="center">
          <b-nav-item
            title="Menu / Shelf Prices"
            v-if="enabledSell"
            :active="active_template === 'PRICE-SELL'"
            @click="active_template = 'PRICE-SELL'"
            >Menu / Shelf Prices
          </b-nav-item>
          <b-nav-item
            v-if="enabledGlass"
            :active="active_template === 'PRICE-GLASS'"
            @click="active_template = 'PRICE-GLASS'"
            >By the Glass</b-nav-item
          >
          <b-nav-item
            v-if="enabledYp"
            :active="active_template === 'PRICE-YP'"
            @click="active_template = 'PRICE-YP'"
          >
            Invoice Prices
          </b-nav-item>
        </b-nav>
      </div>
    </div>
    <selling-prices
      v-if="enabledSell && active_template === 'PRICE-SELL'"
      :value="valueSell"
      :slug="slug"
      :presentation-mode="presentationMode"
      :editable="editable"
      @change="$emit('change', { template: 'PRICE', data: $event })"
      @update-order="$emit('update-order', $event)"
      @hide-item="$emit('hide-item', $event)"
      @update-item="$emit('update-item', $event)"
      @remove-item="$emit('remove-item', $event)"
      :target-margin="targetMargin"
      :view-mode="viewMode"
    ></selling-prices>
    <by-the-glass
      v-if="enabledGlass && active_template === 'PRICE-GLASS'"
      :value="valueGlass"
      :slug="slug"
      :presentation-mode="presentationMode"
      :editable="editable"
      @change="$emit('change', { template: 'PRICE', data: $event })"
      @update-order="$emit('update-order', $event)"
      @hide-item="$emit('hide-item', $event)"
      @update-item="$emit('update-item', $event)"
      @remove-item="$emit('remove-item', $event)"
      :target-margin="targetMarginGlass"
      :view-mode="viewMode"
    ></by-the-glass>
    <your-prices
      v-if="enabledYp && active_template === 'PRICE-YP'"
      :value="valueYp"
      :slug="slug"
      :presentation-mode="presentationMode"
      :editable="editable"
      @change="$emit('change', { template: 'PRICE', data: $event })"
      @update-order="$emit('update-order', $event)"
      @hide-item="$emit('hide-item', $event)"
      @update-item="$emit('update-item', $event)"
      @remove-item="$emit('remove-item', $event)"
      :view-mode="viewMode"
    ></your-prices>
  </div>
</template>

<script>
import YourPrices from "@/components/winelist/WineListYourPrices";
import SellingPrices from "@/components/winelist/WineListYourSellingPrices";
import ByTheGlass from "@/components/winelist/WineListByTheGlass";

export default {
  props: {
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    slug: {
      type: String,
    },
    enabledYp: {
      type: Boolean,
      default: false,
    },
    enabledSell: {
      type: Boolean,
      default: false,
    },
    enabledGlass: {
      type: Boolean,
      default: false,
    },
    valueYp: {
      type: [Array, Boolean],
      default: false,
    },
    valueGlass: {
      type: [Array, Boolean],
      default: false,
    },
    valueSell: {
      type: [Array, Boolean],
      default: false,
    },
    targetMargin: {
      type: Number,
      default: 0,
    },
    targetMarginGlass: {
      type: Number,
      default: 0,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    YourPrices,
    SellingPrices,
    ByTheGlass,
  },
  methods: {},
  data() {
    return {
      active_template: "",
      data_incoming: false,
      templateYp: false,
      templateGlass: false,
      templateSell: false,
    };
  },
  mounted() {
    this.data_incoming = true;

    if (this.enabledGlass) {
      this.active_template = "PRICE-GLASS";
      this.templateGlass = JSON.parse(JSON.stringify(this.valueGlass));
    }

    if (this.enabledYp) {
      this.active_template = "PRICE-YP";
      this.templateYp = JSON.parse(JSON.stringify(this.valueYp));
    }

    if (this.enabledSell) {
      this.active_template = "PRICE-SELL";
      this.templateSell = JSON.parse(JSON.stringify(this.valueSell));
    }
  },
  watch: {
    valueYp: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        this.templateYp = JSON.parse(JSON.stringify(val));
      },
    },
    valueSell: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        this.templateSell = JSON.parse(JSON.stringify(val));
      },
    },
    valueGlass: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        this.templateGlass = JSON.parse(JSON.stringify(val));
      },
    },
  },
};
</script>